import { usePersistedFilters } from '~/hooks/usePersistedFilters'
import type { CivilDate } from '~/models/civilDate'
import {
  JEPX_SETTLEMENT_FILTERS_STORAGE_KEY,
  type JepxSettlementFilters,
  defaultJepxSettlementFilters,
  jepxSettlementFiltersCodec,
} from '~/pages/JepxSettlement/models/persistedFilters'

type UsePersistedJepxSettlementFiltersResult = {
  from: CivilDate | undefined
  setFrom: (value: CivilDate | undefined) => void
  to: CivilDate | undefined
  setTo: (value: CivilDate | undefined) => void
  /** 期間をクリアして「すべて」に戻す (戻した状態も保持する)。 */
  clear: () => void
}

/**
 * 清算日の期間 (開始日・終了日) を localStorage に保持し、 他画面への遷移や再訪を
 * またいで復元する hook (AC-SC-031 [P0])。
 *
 * 直列化・復元・既定値・検証は `models/persistedFilters.ts` の純関数が SoT。
 * 読み書きのタイミング (初期復元 / 変更時の書き戻し / 未操作の既定値は書かない /
 * Strict Mode 対策) は共通 hook が持つ。 市場タブは保持しない (同 model の docstring)。
 */
export function usePersistedJepxSettlementFilters(): UsePersistedJepxSettlementFiltersResult {
  const { filters, updateFilters } = usePersistedFilters<JepxSettlementFilters>(
    {
      storageKey: JEPX_SETTLEMENT_FILTERS_STORAGE_KEY,
      codec: jepxSettlementFiltersCodec,
    },
  )

  return {
    from: filters.from,
    setFrom: (value) => updateFilters((prev) => ({ ...prev, from: value })),
    to: filters.to,
    setTo: (value) => updateFilters((prev) => ({ ...prev, to: value })),
    clear: () => updateFilters(() => defaultJepxSettlementFilters()),
  }
}
